import Vue from 'vue'
import { AxeItems } from '@/models/axeItems'
//import { createElementFromTemplate, Template } from '@/utils/template'
//import {AxEDispatchWindowEvents} from '@/utils/events'

/**
 * 商品詳細ページの閲覧履歴をハンドリングする。
 * Actions:
 *   - 履歴追加: addBrowsingHistoryWithItemDetailId
 *   - レンダリング: renderBrowsingHistories
 */
const LocalStorageKey = 'axe-item-browsing-histories'

export const getBrowsingHistories = () => {

  return itemBrowsingHistories
    .map((id) => AxeItems.getItemByItemDetailId(id))
    .filter((r) => !!r && r.itemPageThumbnailImage)
}

export const getBrowsingHistoriesExcludingCurrentPage = () => {
  return getBrowsingHistories().filter((item) => !(item && window.location.pathname.endsWith(item.itemPageUrl)))
}

/**
 * 商品閲覧履歴をレンダリングするMethod
 */
export const renderBrowsingHistories = (event, $elm: HTMLElement, callbackFunction) => {
  const items = getBrowsingHistoriesExcludingCurrentPage()
  items.forEach((item) => {})
  // callback
  // console.log(`callbackFunction: ${callbackFunction}`)
  // console.log(`window[callbackFunction]:`, window[callbackFunction])
  if (callbackFunction && typeof window[callbackFunction] === 'function') {
    // @ts-ignore
    window[callbackFunction]()
  }
}

/**
 * 商品詳細ページの onLoad event などで呼ばれる、閲覧履歴へ追加するmethod
 */
export const addBrowsingHistoryWithItemDetailId = (event, $elm, itemDetailId) => {
  // historyに追加しつつ重複分 (過去閲覧) 削除
  if (!itemDetailId) {
    return
  }
  const itemData = AxeItems.getItemByItemDetailId(itemDetailId)

  if (itemData && itemData.itemPageThumbnailImage) {
    itemBrowsingHistories = [String(itemDetailId), ...itemBrowsingHistories]
      .filter((v, i, arr) => arr.indexOf(v) == i)
      .slice(0, 10) // 10アイテムまで
  }
  _saveHistories()
}

const _restoreHistories = () => {
  try {
    const str = localStorage.getItem(LocalStorageKey) || '[]'
    return JSON.parse(str) as string[]
  } catch (err) {
    return []
  }
}
const _saveHistories = () => {
  localStorage.setItem(LocalStorageKey, JSON.stringify(itemBrowsingHistories))
}

let itemBrowsingHistories: string[] = _restoreHistories()
